import { Observable } from 'rxjs';
import { Action } from 'redux';
import { ofType, StateObservable } from 'redux-observable';
import { map, withLatestFrom } from 'rxjs/operators';
import {
  CANCEL_SUBSCRIPTION_SUCCESS,
  CREATE_SUBSCRIPTION_SUCCESS,
} from '../actions';
import {
  CancelSubscriptionSuccess,
  CreateSubscriptionSuccess,
} from '../action-creators';
import { push } from 'connected-react-router';
import AppState from '@webapp/store/state';

export const redirectAfterSubscribeEpic = (
  action$: Observable<Action>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Action, CreateSubscriptionSuccess | CancelSubscriptionSuccess>(
      CREATE_SUBSCRIPTION_SUCCESS,
      CANCEL_SUBSCRIPTION_SUCCESS
    ),
    withLatestFrom(state$),
    map(([action, state]) => {
      const isFirstArtist = !state.artist.myArtists.length;

      if (action.type === CREATE_SUBSCRIPTION_SUCCESS) {
        const isUniqueArtist = !state.artist.myArtists.some(
          (artist) => artist.id !== action.clientId
        );

        if (action.redirectTo) {
          return push(action.redirectTo);
        }

        if (isFirstArtist) {
          return push('/dashboard');
        }

        if (action.subscriptionType) {
          return push(
            `/artist/subscriptions?success=${action.subscriptionType}`
          );
        }

        if (isUniqueArtist) {
          return push('/dashboard');
        }

        if (action.change === 'DOWNGRADE') {
          return push(
            `/plans/${action.newSubscription.clientId}/${action.newSubscription.id}/downgrade-success`
          );
        }
      }

      return push('/artist/subscriptions');
    })
  );
